export const CellState = {
  Default: 'default',
  Start: 'start',
  Mid: 'mid',
  End: 'end',
  Selected: 'selected',
  Disabled: 'disabled',
} as const
export type CellState = (typeof CellState)[keyof typeof CellState]

export const CalendarMode = {
  Years: 'years',
  Months: 'months',
  Days: 'days',
  Times: 'times',
} as const

export type CalendarMode = (typeof CalendarMode)[keyof typeof CalendarMode]

export interface CalendarPeriod {
  start: Date
  end: Date
}
export type CalendarDraftPeriod = Partial<CalendarPeriod>
export type CalendarDate = Date | CalendarPeriod
